import { BrowserRouter, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Auth from "@/pages/Auth";
import CustomerApp from "@/pages/CustomerApp";
import DriverDashboard from "@/pages/DriverDashboard";
import AuthCallback from "@/pages/AuthCallback";
import { InstallPrompt } from "@/components/InstallPrompt";
import { Loader2 } from "lucide-react";

function Gate() {
  const location = useLocation();
  const { user, loading } = useAuth();

  // Process Google OAuth callback FIRST (synchronous, before any auth checks).
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0c111c]">
        <Loader2 className="h-7 w-7 animate-spin text-[#ff6a00]" />
      </div>
    );
  }

  if (!user) return <Auth />;
  return user.role === "admin" ? <DriverDashboard /> : <CustomerApp />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Gate />
          <InstallPrompt />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
